// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/yale/" + chunkId + "." + {"130":"9494a35bdbcea14d1aa5","311":"6ba5b8fe1ef66c3dc93c","608":"045752d0e3f2226597be","706":"b5af3b12ad82457de06d","752":"e4a16e3fff3f13f108f2","765":"6b2959163df31bd81b1e","766":"2d4f18ab75c77c78fbff"}[chunkId] + ".js";
};